module.exports = __webpack_public_path__ + "img/20220416_145544.61b93cd1.jpg";